import React from "react";
import Navbar from "../../../Navbar/Navbar";
import FormTakeMoney from "./FormTakeMoney";
import swal from "sweetalert";

class TakeMoney extends React.Component {
  constructor() {
    super();
    this.state = {
      savekrdn: false,
      isSaving: false
    };
  }

  onSaveChange = (P_nawe_barez, P_zh_barez, P_wargr, P_brePara, P_joripara, M_FIB, M_cash) => {
    // Prevent duplicate saves
    if (this.state.isSaving) {
      return;
    }

    if (!window.navigator.onLine) {
      swal({
        title: "ببورە",
        text: "هێڵی ئنتەرنێتەکەت کێشەی هەیە",
        icon: "error"
      });
    } else if (
      P_nawe_barez.toString().length == 0 ||
      P_zh_barez == 0 ||
      P_wargr == null ||
      P_brePara == 0 ||
      P_joripara == null 
    ) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      this.setState({
        savekrdn: true,
        isSaving: true
      });
      swal({
        title: "تەواو",
        text: "پسولە سورکەوتوو بوو!",
        icon: "success",
        timer: 3000
      });

      // Reset saving state after 2 seconds
      setTimeout(() => {
        this.setState({ isSaving: false });
      }, 2000);
    }
  };

  onNewPage = () => {
    this.setState({
      savekrdn: false,
      isSaving: false
    });
  };
  render() {
    return (
      <>
        <Navbar />
        <div className="mt5"></div>
        <FormTakeMoney
          onNewPage={this.onNewPage}
          onSaveChange={this.onSaveChange}
          savekrdn={this.state.savekrdn}
          isSaving={this.state.isSaving}
        />
      </>
    );
  }
}

export default TakeMoney;
